import { useEffect, useState } from "react";
import { connect } from "react-redux";
import Swal from "sweetalert2";
import { requestStoreSave } from "../../Redux/actions";
import { bindActionCreators } from "redux";
import { add } from "date-fns";
import { o } from "@table-library/react-table-library/styles-492c6342";

function StoreAdd(props) {
    const [addmodal, setaddModal] = useState(false);
    const [errorCategory, seterrorCategory] = useState("");
    const [errorDescription, seterrorDescription] = useState("");
    const [errorTaxRate, seterrorTaxRate] = useState("");
    const [errorCutOff, seterrorCutOff] = useState("");
    const [errorHSN, seterrorHSN] = useState("");
    const [adddata, setadddata] = useState({
        category: "", description: "", shortName: "", taxRate: 0, cutOff: 5, hsn: ""
    });

    function validateAddHSN() {
        let formIsValid = false;
        if (!adddata.hsn) {
            formIsValid = false;
            seterrorHSN("*Enter HSN.");
        } else if (!/^\d{3}$/.test(adddata.hsn)) {
            formIsValid = false;
            seterrorHSN("*Enter valid HSN.");
        } else {
            formIsValid = true;
            seterrorHSN("");
        }
        return formIsValid;
    }

    function validateAddCutOff() {
        let formIsValid = false;
        const str = String(adddata.cutOff);  // Convert to string

        if (!str) {
            seterrorCutOff("*Enter cut off.");
        } else if (!/^\d{1,3}$/.test(str)) {
            seterrorCutOff("*Enter valid cut off (1 to 3 digits).");
        } else {
            formIsValid = true;
            seterrorCutOff("");
        }
        return formIsValid;
    }

    function validateAddTaxRate() {
        let formIsValid = false;
        const taxRateStr = String(adddata.taxRate);  // Convert to string

        if (!taxRateStr) {
            seterrorTaxRate("*Enter tax rate.");
        } else if (!/^\d{1,3}$/.test(taxRateStr)) {
            seterrorTaxRate("*Enter valid tax rate (1 to 3 digits).");
        } else {
            formIsValid = true;
            seterrorTaxRate("");
        }

        return formIsValid;
    }

    function validateAddCategory() {
        let formIsValid = false;
        if (!adddata.category) {
            formIsValid = false;
            seterrorCategory("*Enter Category.");
        } else {
            formIsValid = true;
            seterrorCategory("");
        }
        return formIsValid;
    }

    function validateAddDescription() {
        let formIsValid = false;
        if (!adddata.description) {
            formIsValid = false;
            seterrorDescription("*Enter Description.");
        } else {
            formIsValid = true;
            seterrorDescription("");
        }
        return formIsValid;
    }

    function validateAddForm() {
        let hsn = validateAddHSN(); let cutoff = validateAddCutOff(); let taxRate = validateAddTaxRate(); let category = validateAddCategory(); let description = validateAddDescription();
        let valid = hsn && cutoff && taxRate && category && description;
        if (!valid) {
            Swal.fire({
                icon: "error",
                title: "Oops...",
                text: "Please fill all the required fields correctly.",
            });
        }
        return valid;
    }
    const onchangeadddata = (event) => {
        setadddata((adddata) => ({
            ...adddata,
            [event.target.name]: event.target.value,
        }));
    };
    const addtoggle = () => setaddModal(!addmodal);

    const handleCancel = (e) => {
        // e.preventDefault(); // Safeguards against form submission
        addtoggle();    // Close the modal
    };

    const saveaddtoggle = (e) => {
        e.preventDefault();
        let data1 = JSON.parse(localStorage.getItem("user"));
        if (data1) {
            if (validateAddForm()) {
                props.requestStoreSave({
                    data: {
                        userToken: data1.data.userToken,
                        //      compToken: localStorage.getItem('companyToken'),
                        compToken: '611337539322',
                        category: adddata.category,
                        description: adddata.description,
                        quantity: adddata.quantity,
                        freeQty: adddata.freeQty,
                        shortName: adddata.shortName,
                        hsn: adddata.hsn,
                        warranty: adddata.warranty,
                        taxRate: adddata.taxRate
                    },
                });
                setadddata({
                    category: "", description: "", quantity: 0, freeQty: 0, barcode: "", hsn: "", warranty: 0, taxRate: 0
                });
                addtoggle();
            }
        }
    };

    useEffect(() => {
        let addData = props.data.storeSaveData;
        if (addData !== undefined) {
            if (addData.data.status === 1) {
                console.log(addData.data.status);
                addtoggle();
                if (addData?.data?.data) {
                    console.log(addData.data.data);
                    localStorage.removeItem("store");
                    localStorage.setItem("store", addData.data.data);
                }
                Swal.fire({
                    title: "Good job!",
                    text: addData.data.message,
                    icon: "success",
                });
            }
        }
        props.data.storeSaveData = undefined;
        addData = undefined;
    }, [props.data.storeSaveData]);

    return (
        adddata === null ? <div>Loading...</div> :
            <div className="product-view">
                <form class="forms-sample">
                    <div class="form-group">
                        <label>Category</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Category"
                            name="category"
                            value={adddata.category}
                            onBlur={validateAddCategory}
                            onChange={onchangeadddata}
                        />
                        {errorCategory && <p>{errorCategory}</p>}
                    </div>
                    <div class="form-group">
                        <label>Short Name</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="ShortName"
                            name="shortName"
                            value={adddata.shortName}
                            onChange={onchangeadddata}
                        />
                    </div>
                    <div class="form-group">
                        <label>Description</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Description"
                            name="description"
                            value={adddata.description}
                            onBlur={validateAddDescription}
                            onChange={onchangeadddata}
                        />
                        {errorDescription && <p>{errorDescription}</p>}
                    </div>
                    <div class="form-group">
                        <label>Tax Rate</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Tax Rate"
                            name="taxRate"
                            value={adddata.taxRate}
                            onBlur={validateAddTaxRate}
                            onChange={onchangeadddata}
                        />
                        {errorTaxRate && <p>{errorTaxRate}</p>}
                    </div>
                    <div class="form-group">
                        <label>Cut Off</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="Cut Off"
                            name="cutOff"
                            value={adddata.cutOff}
                            onBlur={validateAddCutOff}
                            onChange={onchangeadddata}
                        />
                        {errorCutOff && <p>{errorCutOff}</p>}
                    </div>
                    <div class="form-group">
                        <label>HSN</label>
                        <input
                            type="text"
                            class="form-control"
                            placeholder="hsn"
                            name="hsn"
                            value={adddata.hsn}
                            onBlur={validateAddHSN}
                            onChange={onchangeadddata}
                        />
                        {errorHSN && <p>{errorHSN}</p>}
                    </div>
                    <button
                        type="submit" class="btn btn-primary me-2" onClick={saveaddtoggle} >
                        Save
                    </button>
                    <button
                        class="btn btn-light"
                        onClick={addtoggle}
                    >
                        Cancel
                    </button>
                </form>
            </div>
    )
}

const mapStateToProps = (state) => {
    return { data: state.data };
};

const mapDispatchToProps = (dispatch) =>
    bindActionCreators({ requestStoreSave }, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(StoreAdd);